import { CarrierVisitsApi, UpsertOrderListCommandV2 } from '@planning/app/api'
import { createApiClient } from '@planning/app/http-client'

class CarrierVisitService {
  httpClient = createApiClient(CarrierVisitsApi)

  async delete(id: number) {
    await this.httpClient._delete(id)
  }

  orders = async (visitId: number) => {
    return await this.ordersByCarrierVisitIds([visitId])
  }

  ordersByCarrierVisitIds = async (visitIds: number[]) => {
    const { data } = await this.httpClient.ordersByCarrierVisitIds({ carrierVisitIds: visitIds })

    return data
  }

  containers = async (visitId: number) => {
    return await this.containersByCarrierVisitIds([visitId])
  }

  containersByCarrierVisitIds = async (visitIds: number[]) => {
    const { data } = await this.httpClient.containersByCarrierVisitIds({ ids: visitIds })

    return data
  }

  visits = async (startDate: string, endDate: string) => {
    const { data } = await this.httpClient.getVisits(startDate, endDate)

    return data
  }

  async upsertOrderListV2(upsertOrderListCommand: UpsertOrderListCommandV2) {
    await this.httpClient.orders_1(upsertOrderListCommand)
  }
}

const carrierVisitService = new CarrierVisitService()

export default carrierVisitService
